<template>
    <v-card>
        <loading-component :value="loading"/>
        <v-card-title primary-title class="font-weight-bold title">
            Create a new interview
            <template v-if="interview.captain">
                For {{interview.captain.first_name}} {{interview.captain.last_name}}
            </template>
        </v-card-title>
        <v-divider/>
        <v-card-text>
            <v-form ref="form">
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                            <template slot="activator">
                                <v-text-field
                                        v-model="interview.date"
                                        label="Date"
                                        prepend-icon="event"
                                        :rules="[v => !!v || 'Required Field']"
                                        readonly
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="interview.date"></v-date-picker>
                        </v-menu>
                        <v-menu
                                :close-on-content-click="false"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                        >
                            <template slot="activator">
                                <v-text-field
                                        v-model="interview.time"
                                        label="Time"
                                        prepend-icon="event"
                                        :rules="[v => !!v || 'Required Field']"

                                        readonly
                                ></v-text-field>
                            </template>
                            <v-time-picker v-model="interview.time"></v-time-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs8>
                        <choose-captains-multi
                                v-if="enableChangeCaptain"
                                :multi="false" :rules="[v => !!v || 'Required Field']"
                                v-model="interview.captain" label="Captain" return-object/>
                    </v-flex>
                    <v-flex xs4 v-if="showCreateCaptain">
                        <v-btn @click="$emit('create_captain')" color="primary" v-if="hasPermission('CREATE_CAPTAINS')">
                            Create captain
                        </v-btn>
                    </v-flex>
                    <v-flex xs12>
                        <v-select
                                :items="statuses"
                                item-text="name"
                                item-value="id"
                                v-model="interview.interview_status_id"
                                :rules="[v => !!v || 'Required Field']"
                                label="Status"
                                solo
                        ></v-select>
                    </v-flex>
                    <v-flex xs12>
                        Whatsapp Number:
                        <v-select :items="whatsappNumbers"
                                  item-text="number"
                                  item-value="value"
                                  v-model="interview.whatsapp_from"
                                  label="Whatsapp Number"
                                  solo/>
                    </v-flex>
                </v-layout>
                <v-layout justify-end>
                    <v-btn color="success" flat @click="saveInterview">
                        Save
                    </v-btn>
                </v-layout>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        components: {ChooseCaptainsMulti, LoadingComponent},
        name: "InterviewEditor",
        props: {
            captain: {
                type: Object,
                default: () => null
            },
            statuses: {
                type: Array,
                required: true
            },
            showCreateCaptain: {
                type: Boolean,
                default: true
            },
            enableChangeCaptain: {
                type: Boolean,
                default: true
            },
            action: {
                type: Function,
                default: null
            }
        },
        data() {
            return {
                loading: false,
                interview: {
                    date: null,
                    time: null,
                    captain: this.captain,
                    interview_status_id: null,
                    whatsapp_from: null
                }
            }
        },
        computed: {
            whatsappNumbers() {
                const numbers = this.$store.state.user.settings.WHATSAPP_NUMBERS;
                return [{
                    number: "Default",
                    value: null
                }, ...numbers.map(number => ({number, value: number}))]
            }
        },
        methods: {
            async saveInterview() {
                if (!this.$refs.form.validate()) {
                    window.getApp.$emit("SHOW_TOAST", "Check Errors", "red");
                    return;
                }

                this.loading = true;
                if (this.action) {
                    await this.action(this.interview);
                    this.loading = false;
                    return;
                }

                const {captain, interview_status_id, whatsapp_from} = this.interview;

                this.axios.post(
                    this.api.ACTIONS.INTERVIEWS,
                    {
                        datetime: this.interview.date + ' ' + this.interview.time,
                        captain_id: captain.id,
                        interview_status_id,
                        whatsapp_from

                    }
                ).then(
                    ({data: {data: interview}}) => {
                        window.getApp.$emit("SHOW_TOAST", "Saved", "green");
                        this.$emit("saved", interview, captain);
                    }
                ).catch(
                    () => window.getApp.$emit("SHOW_TOAST", "Error happened please check error log", "red")
                ).finally(() => this.loading = false)

            }
        }
    }
</script>

<style scoped>

</style>
